import { PageInit } from "luxedo-comps"
import {
	DataHandlerDesign,
	DataHandlerUser,
	DataHandlerUserAdmin,
	DataHandlerFolderAdmin,
	DataHandlerMediaAdmin,
	DeviceSpotlightManager,
	DataHandlerDevice,
} from "luxedo-data"
import { UserStore } from "../../stores/UserStore"
import { FileSystemMedia } from "../FileSystems"
import { LuxedoRPC } from "luxedo-rpc"
import { POLL_INTERVAL_SLOW, POLL_INTERVAL_SLOW_DEV } from "luxedo-rpc/src/backend/consts"

const DATAHANDLERS = [
	DataHandlerUserAdmin,
	DataHandlerFolderAdmin,
	DataHandlerMediaAdmin,
	DataHandlerDesign,
	DataHandlerDevice,
]

export const pageInit = new PageInit(
	// @ts-ignore
	DATAHANDLERS,
	DataHandlerUser,
	import.meta.env.VITE_API_URL,
	UserStore.set,
)

pageInit.postInit(() => {
	FileSystemMedia.initialize()
	DeviceSpotlightManager.initialize()

	LuxedoRPC.backend.startPolling(import.meta.env.PROD ? POLL_INTERVAL_SLOW : POLL_INTERVAL_SLOW_DEV)
})
